import styled from 'styled-components';

// -----------COMMON---------------------------------------------------------------
export const StyledSaveButton = styled.button<{margin?: string; disabled?: boolean}>`
  background: ${props => props.disabled? '#888888' : '#233567' };
  color: #FFFFFF;
  border: 0;
  height: 35px;
  padding: 0 15px;
  margin: ${props=> props.margin? props.margin : '0 10px'};
  font-size: 16px;
  border-radius: 35px;
  cursor: pointer;
`;

export const StyledRemoveButton = styled.button`
  background: #CC6666;
  color: #FFFFFF;
  border: 0;
  height: 35px;
  padding: 0 15px;
  margin: 0 10px;
  font-size: 16px;
  border-radius: 35px;
  cursor: pointer;
`;

export const StyledStandardButton = styled.button<{background?: string; text?: string}>`
    background: ${props => props.background};    
    color: ${props => props.text=='Cancel'? '1px solid #888888' : '1px solid #233567'};
    border: ${props => props.text=='Cancel'? '1px solid #888888' : '1px solid #233567'};
    width: 100px;
    height: 35px;
    margin: 0 1px;
    font-size: 15px;
    border-radius: 35px;
    cursor: pointer;
    margin-left: 75%;
    margin-top: 60px;
    &:hover {
        background:  ${props => props.text=='Cancel'? '#888888' : '#233567'};
        color: #FFF;
      }
    &:focus {
        background:  ${props => props.text=='Cancel'? '#888888' : '#233567'};
        color: #FFF;
    }
`;

// Toggle
export const StyledToggle = styled.div<{selected?: boolean;}>`
  position: relative;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  background-color: ${props => props.selected? '#233567' : '#cccccc'};
  cursor: pointer;
`;

// Checkbox
export const StyledCheckBox = styled.input`
  display: inline-block;
  border-radius: 15px;
  margin: 0 20px 0 0 ;
  &:checked  {
      background: '#233567';
      color: '#233567';
}`

// Switch
export const StyledSwitch = styled.div<{selected?: boolean;}>`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  top: 2px;
  left: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  ${props => props.selected? 'transform: translateX(20px);' : null}
  background-color: #FFF;
`;


// -------CAPABILITIES--------------------------------------------------------------

export const StyledTestButton = styled.button`
  background: #233567;
  color: #FFFFFF;
  border: 0;
  
  font-size: 1em;
  border-radius: 35px;
  cursor: pointer;
  width: 100px;
`;

// ---------------------------------------------------------------------------------